export const checkoutUrl =
  'https://brazilian-jiu-jitsu-instructor-ready.impultienda.ar/checkout'

export const productName = 'Brazilian Jiu Jitsu Coach Ready'

export const ctaLabel = 'GET BRAZILIAN JIU JITSU COACH READY'
export const ctaLabelSystem = 'YES, I WANT THE COMPLETE SYSTEM'
export const ctaLabelAccess = 'GET INSTANT ACCESS'

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Brazilian Jiu Jitsu Coach Ready — 6-in-1 Complete System',
    value: 27,
    currency: 'USD',
  })
}

export const packageContents: { icon: string; label: string }[] = [
  {
    icon: '📗',
    label:
      'Volume 1 — Fundamental movement, safety, positioning and guard foundations — 25 Lessons',
  },
  {
    icon: '📘',
    label:
      'Volume 2 — Escapes, defensive skills and guard passing fundamentals — 25 Lessons',
  },
  {
    icon: '📙',
    label:
      'Volume 3 — Positional control, transitions and takedown fundamentals — 25 Lessons',
  },
  {
    icon: '📕',
    label:
      'Volume 4 — Submissions, advanced technique, assessment and annual planning — 25 Lessons',
  },
  {
    icon: '🔧',
    label: 'Essential Tool 1 — Coaching Cues, Corrections & Common Mistakes',
  },
  {
    icon: '🔧',
    label: 'Essential Tool 2 — 200 Drills, Training Games & Skill Challenges',
  },
  { icon: '🎁', label: 'Bonus 1 — BJJ Technique Breakdown Library' },
  { icon: '🎁', label: 'Bonus 2 — 36-Week BJJ Curriculum Map' },
  { icon: '🎁', label: 'Bonus 3 — Student Progress & Belt Assessment System' },
  { icon: '🎁', label: 'Bonus 4 — Private, Group & Academy Adaptation System' },
  { icon: '🎁', label: 'Bonus 5 — 30 Emergency & Limited Space Classes' },
  { icon: '✅', label: '7-Day Money Back Guarantee' },
]

export const finalIncludedItems: string[] = [
  'Volume 1 — Fundamental movement, safety, positioning and guard foundations — 25 Lessons',
  'Volume 2 — Escapes, defensive skills and guard passing fundamentals — 25 Lessons',
  'Volume 3 — Positional control, transitions and takedown fundamentals — 25 Lessons',
  'Volume 4 — Submissions, advanced technique, assessment and annual planning — 25 Lessons',
  'Essential Tool 1 — Coaching Cues, Corrections & Common Mistakes',
  'Essential Tool 2 — 200 Drills, Training Games & Skill Challenges',
  'Bonus 1 — BJJ Technique Breakdown Library',
  'Bonus 2 — 36-Week BJJ Curriculum Map',
  'Bonus 3 — Student Progress & Belt Assessment System',
  'Bonus 4 — Private, Group & Academy Adaptation System',
  'Bonus 5 — 30 Emergency & Limited Space Classes',
  '7-Day Money Back Guarantee',
  'Immediate Access',
  'Pay in your local currency',
  'PDF format — ready to use',
]
